export const LODGING_READ = "lodging.read";
export const LODGING_BOOK = "lodging.book";
export const LODGING_OVERRIDE = "lodging.override";
export const LODGING_RATES = "lodging.rates";
export const LODGING_SETTINGS = "lodging.settings";
/** Check in, check out (and, with lodging.book, move a stay in house). */
export const LODGING_CHECKIN = "lodging.checkin";
/** Folio lines, window 2 and payers. */
export const LODGING_FOLIO = "lodging.folio";
/** Settling, refunding a settled line and voiding a settlement. */
export const LODGING_SETTLE = "lodging.settle";
/** The housekeeping board, task steps and dirty / cleaning / clean. */
export const LODGING_HOUSEKEEPING = "lodging.housekeeping";
/** Inspecting, planning and assigning tasks, out of order, housekeepers, tablets and units' work orders. */
export const LODGING_HOUSEKEEPING_MANAGE = "lodging.housekeeping.manage";

/** The Jonas hotel import: status, settings, layouts, the setup and history previews and imports, the reconciliation. */
export const LODGING_IMPORT = "lodging.import";

/** Other modules' permissions that decide whether a picker may search them. */
export const MEMBERS_READ = "members.read";
export const BILLING_READ = "billing.read";
/** Billing's overrides offered when settling again after a refusal. */
export const BILLING_ADJUST = "billing.adjust";
export const BILLING_CLOSE = "billing.close";
